import React, { useEffect } from 'react';
import { T, M, A } from 'TOMA';
import styles from './event-exhibitors.module.scss';
import ThumbnailExhibitor from '../../../components/ThumbnailExhibitor/ThumbnailExhibitor';
import s from '../../../components/Header/Header.module.scss';
import { ExhibitorRepository } from '../../../services/Exhibitor/Exhibitor.repository';
import { CodificationRepository } from '../../../services/Codification/Codification.repository';
import { EventRepository } from 'services/Event/Event.repository';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';

export default function Events(): JSX.Element {
  const [exhibitors, setExhibitors] = React.useState<any[]>([]);
  const [event, setEvent] = React.useState<any>(null);
  const [isRefreshing, setIsRefreshing] = React.useState<boolean>(false);
  const exhibitorRepo = new ExhibitorRepository();
  const eventRepo = new EventRepository();

  const { slug } = useParams();
  useEffect(() => {
    eventRepo.getPublicEventBySlug(slug ?? '').then((data) => {
      const eventData = Array.isArray(data) ? data[0] : data;
      setEvent({
        ...eventData,
        logo:
          eventData.company_logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${eventData.company_logo_uuid}.${eventData.company_logo_extension}`
            : null,
      });
    });

    exhibitorRepo.searchBySlug(slug ?? '', { per_page: 5000 }).then((data) => {
      const formattedData = data.data.map((exhibitor) => ({
        ...exhibitor,
        logo:
          exhibitor.logo_uuid &&
          exhibitor.logo_extension &&
          process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${exhibitor.logo_uuid}.${exhibitor.logo_extension}`
            : null,
        showroom_logo:
          exhibitor.showroom_logo_uuid &&
          exhibitor.showroom_logo_extension &&
          process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${exhibitor.showroom_logo_uuid}.${exhibitor.showroom_logo_extension}`
            : null,
      }));
      setExhibitors(formattedData);
    });
  }, [slug]);

  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <>
      {event && (
        <div style={{ backgroundColor: event.color || '#000000' }}>
          <T.Block>
            <T.Container>
              <T.Flex halign="space-between" py="40" gap={4}>
                <T.Col>
                  <>
                    <T.Block my="10">
                      <A.Image
                        className="hidden"
                        src={event.logo || ''}
                        height="40"
                        width="auto"
                      />
                    </T.Block>
                    <A.Text color="white" mb="10" fontSize="24" fw="bold">
                      {event.name}
                    </A.Text>
                    <A.Text color="white" mb="10" fontSize="18">
                      {event.subtitle}
                    </A.Text>
                    <div className={s.Header__line}></div>

                    <T.Block mt="15">
                      <A.Text color="white" fontSize="18">
                        <T.Flex className="flex" gap={1}>
                          <div>
                            <A.Icon icon="calendar2-week-fill" color="white" />
                          </div>
                          <div>
                            Du {event?.date} au {event?.date_of_the_end}
                          </div>
                          <div>
                            <A.Icon icon="geo-fill" color="white" />
                          </div>
                          <div>
                            {event.city}, {event.country}
                          </div>
                        </T.Flex>
                      </A.Text>
                    </T.Block>
                  </>
                </T.Col>
              </T.Flex>
            </T.Container>
          </T.Block>
        </div>
      )}
      <div className={styles.ExhibitorList}>
        <BreadCrumb
          breadCrumb={[
            // {
            //   icon: null,
            //   href: '/' + BASE_PATH + '/preview/events',
            //   label: 'Events',
            //   isCurrent: false,
            // },
            {
              icon: null,
              href: undefined,
              label: event ? event.name : 'Event',
              isCurrent: true,
            },
            {
              icon: null,
              href: undefined,
              label: 'List of Exhibitors',
              isCurrent: false,
            },
            {
              icon: null,
              href: `/${BASE_PATH}/preview/events/${slug ?? ''}/products`,
              label: 'List of Products',
              isCurrent: false,
            },
          ]}
        />
        <h1 className={styles.ExhibitorList__title}>List of Exhibitors</h1>
        <M.Loading loading={isRefreshing} overlay>
          {exhibitors.length === 0 && (
            <div className={styles.ExhibitorList__nofound}>
              No exhibitor found...
            </div>
          )}

          <ul className={styles.ExhibitorList__List}>
            {exhibitors.map(
              ({
                id,
                logo,
                nom_societe,
                hall,
                stand,
                showroom,
                showroom_logo,
              }) => (
                <li className={styles.ExhibitorList__List__li} key={id}>
                  <ThumbnailExhibitor
                    id={id}
                    logo={logo}
                    nom_societe={nom_societe}
                    hall={hall}
                    stand={stand}
                    showroom={Number(showroom) === 1}
                    showroom_logo={showroom_logo}
                    slug={slug}
                  />
                </li>
              )
            )}
          </ul>
        </M.Loading>
      </div>
    </>
  );
}
